import { Table, Checkbox } from 'antd';
import { FC } from 'react';
import { t_cpap_instructions } from 'types';

type Props = {
  data: t_cpap_instructions[];
  cpapCheck: { cpap_id: string; patient_name: string; patient_id: string };
  handleCheck: any;
};

const TableModal: FC<Props> = ({ data, cpapCheck, handleCheck }) => {
  const columns: any = [
    {
      title: '',
      dataIndex: 'cpap_id',
      key: 'name',
      width: '10%',
      align: 'center',
      render(text: string, row: t_cpap_instructions, index: number) {
        return {
          props: {
            style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'center' },
            className: 'standardFont',
          },
          children: (
            <div>
              <Checkbox
                value={text}
                checked={text === cpapCheck.cpap_id}
                onChange={(e) => {
                  if (e.target.value === cpapCheck.cpap_id) {
                    handleCheck({
                      cpap_id: '',
                      patient_name: '',
                      patient_id: '',
                      i_id: '',
                      sp_price: '',
                      sort_num: 0,
                    });
                  } else {
                    handleCheck({
                      cpap_id: e.target.value,
                      patient_name: row.patient_name,
                      patient_id: row.patient_id,
                      i_id: row.i_id,
                      sp_price: row.sp_price,
                      sort_num: row.sort_num,
                    });
                  }
                }}
              />
            </div>
          ),
        };
      },
    },
    {
      title: 'ID',
      dataIndex: 'patient_id',
      key: 'patient_id',
      width: '45%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
    {
      title: '利用者名',
      dataIndex: 'patient_name',
      key: 'patient_name',
      width: '45%',
      align: 'center',
      render(text: string) {
        return {
          props: {
            style: { backgroundColor: '#f6f6f6', textAlign: 'left' },
            className: 'standardFont',
          },
          children: <div>{text}</div>,
        };
      },
    },
  ];

  const dataTable = data.findIndex((f) => f.cpap_id === cpapCheck.cpap_id) > -1 ? data : [cpapCheck, ...data];

  return (
    <div>
      <Table
        rowKey="i_id"
        style={{
          boxShadow:
            '0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2)',
        }}
        columns={columns}
        dataSource={dataTable}
        pagination={false}
        scroll={{ y: 300 }}
      />
    </div>
  );
};

export default TableModal;
